// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import axios from 'axios';
// //import '../HospitalList/HospitalList.scss';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   const [hospitals, setHospitals] = useState();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch local storage data
//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   // Function to fetch hospital list
  
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         console.log('API response:', response);
//         if (response) {
//           setHospitals(response); // Assuming response is an array of hospitals
//         } else {
//           console.error('Invalid response format:', response);
//           throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchData();
//   }, []);

//   // if (hospitals) {
//   //   console.log('hospitals @@@@@@@@@@@@@@ ', hospitals);
//   //   return <p>Loading...</p>;
//   // }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
    
//     <div className="hospital-list">
//       <h2>List of Hospitals</h2>
//       <ul>
//         {/* {hospitals.map((item, index) => console.log(item,index))} */}
//         {console.log("hospitals@@@@@@@@@@@@@@@@", hospitals)}
//       </ul>
//     </div>
//   );
// };

// export default HospitalList;



///////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////Testing code:::::::::::This code look like into the card format of the Hospitals Details:::: also a new Updated ccode
//////////////////////////////////////////////////////////////////////////////////////////////////////////


import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import classes from '../HospitalList/HospitalList.module.scss';
import { hospitallist } from '../../API/API';
import Hospital from './Hospital';
import Labs from './Labs';
import ACHC from './ACHC';



const HospitalList = () => {
  const [achcHospitals, setAchcHospitals] = useState([]);
  const [hospitalList, setHospitalList] = useState([]);
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentView, setCurrentView] = useState('');
  const [selectedHospitalDetails, setSelectedHospitalDetails] = useState(null);
  const [selectedHospitalName, setSelectedHospitalName] = useState('');

  const userID = localStorage.getItem('userID');
  const data = JSON.parse(localStorage.getItem('data'));




  useEffect(() => {
    const fetchData = async () => {
      if (!userID || !data?.empid || !data?.token) {
        setError('Missing authentication details.');
        return;
      }

      setLoading(true);
      try {
        const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
          hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
          hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
          hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
        ]);

        if (achcResponse?.data) setAchcHospitals(achcResponse.data);
        if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
        if (labsResponse?.data) setLabs(labsResponse.data);

        setError(null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message || 'Failed to fetch data');
        toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userID, data?.empid, data?.token]);

  



  const handleViewChange = (viewType) => {
    setCurrentView(viewType);
    setSelectedHospitalDetails(null);
    setSelectedHospitalName('');
  };

  const fetchHospitalDetails = async (hospitalName) => {
    if (!userID || !data?.empid || !data?.token) {
      toast.error('Missing authentication details');
      return;
    }

    try {
      setLoading(true);
      const response = await hospitallist('HOSPITAL_ADD', userID, data.empid, data.token, '', {
        cmd: 'HOSPITAL_ADD',
        hosp_nm: hospitalName,
      });

      if (response?.data) {
        const detailObject = Array.isArray(response.data)
          ? response.data[0]
          : response.data;

        setSelectedHospitalDetails(detailObject);
        setSelectedHospitalName(hospitalName);
      } else {
        toast.error('No details found for the selected hospital.');
        setSelectedHospitalDetails(null);
        setSelectedHospitalName('');
      }
    } catch (error) {
      console.error('Error fetching hospital details:', error);
      toast.error(error.message || 'Failed to fetch hospital details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <BreadCrumb name="Hospital List" />
      <div className={classes.ViewHospital}>
        <div className={classes.TableDiv}>
          <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
            List Of Hospitals
          </button>
          <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
            ACHC
          </button>
          <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
            Labs
          </button>
        </div>
      </div>

      <div className={classes.HospitalListContainer}>
        {currentView === 'HOSPITAL' && (
          <Hospital
            hospitalList={hospitalList}
            selectedHospitalDetails={selectedHospitalDetails}
            selectedHospitalName={selectedHospitalName}
            onHospitalClick={fetchHospitalDetails} 
          />
        )}
        {currentView === 'ACHC' && (
          <ACHC
            achcHospitals={achcHospitals}
            selectedHospitalDetails={selectedHospitalDetails}
            selectedHospitalName={selectedHospitalName}
            onHospitalClick={fetchHospitalDetails}
          />
        )}
        {currentView === 'LABS' && (
          <Labs
            labs={labs}
            selectedHospitalDetails={selectedHospitalDetails}
            selectedHospitalName={selectedHospitalName}
            onHospitalClick={fetchHospitalDetails}
          />
        )}
      </div>
    </>
  );
};

export default HospitalList;

















///////////////////// Running Code ///////////////////////////////////////

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {

//   const [hospitals, setHospitals] = useState();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         console.log('API response:', response);
//         if (response) {
//           setHospitals(response); // Assuming response is an array of hospitals
//         } else {
//           console.error('Invalid response format:', response);
//           throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };   
//     fetchData();
//   }, []);

//   // if (hospitals) {
//   //   console.log('hospitals @@@@@@@@@@@@@@ ', hospitals);
//   //   return <p>Loading...</p>;
//   // }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
    
//       <div className={classes.ViewHospital}>
//         {/* <div className={classes.AttendanceDiv}> */}
//           <div className={classes.TableDiv}>
//                {/* <br/> <button type="button" disabled style={{width:"600px"}}>List of Hospitals</button> */}
//                {/* <div className="btn-container"> */}
//                <br/><br/><button type="button" style={{width:"300px", height:"70px", left:"100px"}}>List Of Hospitals</button>
//                <br/><br/><button type="button" style={{width:"300px", height:"70px"}}>ACHC</button>
//                <br/><br/><button type="button" style={{width:"300px", height:"70px"}}>Labs</button>
//                {/* </div> */}
//               {/* </tbody> */}
//             {/* </table> */}
//           </div>
//         </div>
        
//       {/* </div> */}
//       <div className="hospital-list">
//        {/* <h2>List of Hospitals</h2> */}
//          <ul>
//          {/* {hospitals.map((item, index) => console.log(item,index))} */}
//          {console.log("hospitals@@@@@@@@@@@@@@@@", hospitals)}
//        </ul>
//      </div>
//     </>
//   );
// };

// export default HospitalList;

////////////////////////////////////////////////////////////////////////////////////













// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // State to manage hospital list display
//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         console.log('API response:', response);
//         if (Array.isArray(response)) {
//           setHospitals(response);
//         } else {
//           console.error('Invalid response format:', response);
//           throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };   
//     fetchData();
//   }, []);

//   const handleACHCClick = () => {
//     setShowHospitals(true); // Show hospitals when ACHC button is clicked
//   };

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
    
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <br/><br/><button type="button" onClick={handleACHCClick} style={{width:"300px", height:"70px"}}>ACHC</button>
//         </div>
//       </div>
              
      
//     </>
//   );
// };

// export default HospitalList;














// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   // States to manage hospitals, loading, error, and toggle button
//   const [hospitals, setHospitals] = useState([]); // Default to empty array
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // Toggle to show hospitals

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         console.log('API response:', response);

//         // Ensure the response is an array before setting it in state
//         if (Array.isArray(response)) {
//           setHospitals(response); // Set the hospital data if valid
//         } else {
//           throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [userID, data.empid, data.token]);  // Dependencies to re-run if user data changes

//   const handleACHCButtonClick = () => {
//     setShowHospitals(!showHospitals); // Toggle the visibility of hospital list
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: "300px", height: "70px", left: "100px" }}
//           >
//             List Of Hospitals
//           </button>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: "300px", height: "70px" }}
//             onClick={handleACHCButtonClick}
//           >
//             ACHC
//           </button>
//           <br /><br />
//           <button type="button" style={{ width: "300px", height: "70px" }}>
//             Labs
//           </button>
//         </div>
//       </div>

//       {/* Only show hospitals if 'showHospitals' is true and hospitals array is not empty */}
//       {showHospitals && hospitals.length > 0 && (
//         <div className="hospital-list">
//           <ul>
//             {hospitals.map((hospital, index) => (
//               <li key={index}>
//                 <h3>{hospital.name}</h3>
//                 <p>Location: {hospital.location}</p>
//                 <p>Type: {hospital.type}</p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}

//       {/* Handle the case when no hospitals are available */}
//       {showHospitals && hospitals.length === 0 && (
//         <p>No hospitals available.</p>
//       )}
//     </>
//   );
// };

// export default HospitalList;









// ==============================================================================
// 

// ===============================================================================
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {

//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // New state for showing hospitals

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
        
//         console.log('API response:', response);
//         if (response) {
//           setHospitals(response); // Assuming response is an array of hospitals
//         } else {
//           console.error('Invalid response format:', response);
//           throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleACHCButtonClick = () => {
//     setShowHospitals(!showHospitals); // Toggle the state
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: "300px", height: "70px", left: "100px" }}
//           >
//             List Of Hospitals
//           </button>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: "300px", height: "70px" }}
//             onClick={handleACHCButtonClick} // Attach click event handler
//           >
//             ACHC
//           </button>
//           <br /><br />
//           <button type="button" style={{ width: "300px", height: "70px" }}>
//             Labs
//           </button>
//         </div>
//       </div>

//       {showHospitals && (
//         <div className="hospital-list">
//           <ul>
//             {hospitals.map((hospital, index) => (
//               <li key={index}>
//                 <h3>{hospital.name}</h3>
//                 <p>Location: {hospital.location}</p>
//                 <p>Type: {hospital.type}</p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;     






////////////////////------------------------------------------------------------
///////Updated Running Code::::::::
/////////////////////////-------------------------------------------------------

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // Toggle state for hospitals

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         //const response1 = await hospitallist(userID, data.empid, data.token, 'HOSPITAL');
//         console.log('API response:', response);
        
//         // Parse response to access hospital list
//         if (response?.data?.length > 0) {      //  response?.data?.length checks if response exists, its data field exists, and that data is an array with at least one item, all without throwing errors if any field is missing or undefined.
//           setHospitals(response.data); // Directly set the array from response.data
//         } else {
//           throw new Error('No hospitals found or unexpected response format');
//         }
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleACHCButtonClick = () => {
//     setShowHospitals(!showHospitals); // Toggle visibility of the hospital list
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: '300px', height: '70px', left: '100px' }}
//             // onClick={handleHOSPITALButtonClick} 
//           >
//             List Of Hospitals
//           </button>
//           <br /><br />
//           <button
//             type="button"
//             style={{ width: '300px', height: '70px' }}
//             onClick={handleACHCButtonClick} // Attach click event handler
//           >
//             ACHC
//           </button>
//           <br /><br />
//           <button type="button" style={{ width: '300px', height: '70px' }}>
//            {/* onClick={handleLABSButtonClick} */}
//             Labs
//           </button>
//         </div>
//       </div>

//       {showHospitals && hospitals.length > 0 && (
//         <div className="hospital-list">
//           <ul>
//             {hospitals.map((hospital, index) => (
//               <li key={index}>
//                 <h3>{hospital.hsptl_name}</h3>
//                 <p>Category: {hospital.cata}</p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}

//       {showHospitals && hospitals.length === 0 && (
//         <p>No hospitals available to display.</p>
//       )}
//     </>
//   );
// };

// export default HospitalList;




















////////////////////////////////////////////////////////////////////////
////////////// apply outer concepts Code :////////////////////////////////////////
////////////////######################################

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';
// import Hospital from './Hospital';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         console.log('Fetching data for user:', userID); 
        
//         const achcPromise = hospitallist('HOSPITAL',userID, data.empid, data.token, 'ACHC');
//         const hospitalsPromise = hospitallist('HOSPITAL',userID, data.empid, data.token, 'Hospital');
//         const labsPromise = hospitallist('HOSPITAL',userID, data.empid, data.token, 'Lab');

//         // const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//         //   achcPromise,
//         //   hospitalsPromise,
//         //   labsPromise,
//         // ]);

//         console.log('ACHC Response:', achcPromise );
//         console.log('Hospitals Response:', hospitalsPromise);
//         console.log('Labs Response:', labsPromise);

//         if (achcPromise?.data) setAchcHospitals(achcPromise.data);
//         else console.warn('ACHC data is empty or undefined');

//         if (hospitalsPromise?.data) setHospitalList(hospitalsPromise.data);
//         else console.warn('Hospital data is empty or undefined');

//         if (labsPromise?.data) setLabs(labsPromise.data);
//         else console.warn('Labs data is empty or undefined');

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     console.log('Switching view to:', viewType);
//     setCurrentView(viewType);
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   const renderList = (dataList, type) => {
//     console.log(`Rendering ${type} list, Count:`, dataList.length);
//     if (!dataList || dataList.length === 0) return <p>No {type} data available.</p>;

//     return (
//       <table className={classes.Table}>
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Category</th>
//           </tr>
//         </thead>
//         <tbody>
//           {dataList.map((item, index) => (
//             <tr key={index}>
//               <td>{item.hsptl_name}</td>
//               <td>{item.cata}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>
    
//       <div className={classes.HospitalListContainer}>
//         {currentView === 'ACHC' && <><h2>ACHC Hospitals</h2>{renderList(achcHospitals, 'ACHC')}</>}
//         {currentView === 'HOSPITAL' && <><h2>List Of Hospitals</h2>{renderList(hospitalList, 'Hospital')}</>}
//         {currentView === 'LABS' && <><h2>Labs</h2>{renderList(labs, 'Labs')}</>}
//       </div>
//     </>
//   );
// };

// export default HospitalList;



///////////////////////////////////////////////////////////////////////////////////
//////// My updated and Seperated seperated code ::::::::::::::::::::::::::::
///////////////////////////////////////////////////////////////////////////////////
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import { hospitallist } from '../../API/API';
// import Hospital from './Hospital';
// import Labs from './Labs';
// import ACHC from './ACHC';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         console.log('Fetching data for user:', userID);

//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token,'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         setAchcHospitals(achcResponse?.data || []);
//         setHospitalList(hospitalsResponse?.data || []);
//         setLabs(labsResponse?.data || []);
//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     console.log('Switching view to:', viewType);
//     setCurrentView(viewType);
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'HOSPITAL' && <Hospital hospitalList={hospitalList} />}
//         {currentView === 'ACHC' && <ACHC achcHospitals={achcHospitals} />}
//         {currentView === 'LABS' && <Labs labs={labs} />}
//       </div>
//     </>
//   );
// };

// export default HospitalList;



///////////////////////////////////////////////////////////////////////
/////////////////////////New Seperated Code -Its when we click on the Hospitals name then give the details:::::::::::::::::::::::
/////////////////////////////////////////////////////////////////////////
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import { hospitallist } from '../../API/API';
// import Hospital from './Hospital';
// import Labs from './Labs';
// import ACHC from './ACHC';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');
//   const [selectedHospitalDetails, setSelectedHospitalDetails] = useState(null);

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         if (achcResponse?.data) setAchcHospitals(achcResponse.data);
//         if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
//         if (labsResponse?.data) setLabs(labsResponse.data);

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     setCurrentView(viewType);
//     setSelectedHospitalDetails(null); // Clear previously selected details
//   };

//   const fetchHospitalDetails = async (hospitalName) => {
//     if (!userID || !data?.empid || !data?.token) {
//       toast.error('Missing authentication details');
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await hospitallist('HOSPITAL_ADD', userID, data.empid, data.token, '', {
//         cmd: 'HOSPITAL_ADD',
//         hosp_nm: hospitalName,
//       });

//       if (response?.data) {
//         setSelectedHospitalDetails(response.data);
//       } else {
//         toast.error('No details found for the selected hospital.');
//       }
//     } catch (error) {
//       console.error('Error fetching hospital details:', error);
//       toast.error(error.message || 'Failed to fetch hospital details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'HOSPITAL' && (
//           <Hospital hospitalList={hospitalList} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'ACHC' && (
//           <ACHC achcHospitals={achcHospitals} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'LABS' && (
//           <Labs labs={labs} onHospitalClick={fetchHospitalDetails} />
//         )}
//       </div>

//       {selectedHospitalDetails && (
//         <div className={classes.HospitalDetails}>
//           <h3>Hospital Details</h3>
//           <pre style={{ backgroundColor: '#f9f9f9', padding: '10px' }}>
//             {JSON.stringify(selectedHospitalDetails, null, 2)}
//           </pre>
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;


/////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////This is the new code when we click on the Names of Hospitals then show the Details Properly(Use Inline)
/////////////////////////////////////////////////////////////////////////////////////////////////////////s
// import React, { useEffect, useState, useRef } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import { hospitallist } from '../../API/API';
// import Hospital from './Hospital';
// import Labs from './Labs';
// import ACHC from './ACHC';
// import HospitalDetails from './HospitalDetails';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');
//   const [selectedHospitalDetails, setSelectedHospitalDetails] = useState(null);

//   const detailsRef = useRef(null);

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         if (achcResponse?.data) setAchcHospitals(achcResponse.data);
//         if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
//         if (labsResponse?.data) setLabs(labsResponse.data);

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     setCurrentView(viewType);
//     setSelectedHospitalDetails(null);
//   };

//   const fetchHospitalDetails = async (hospitalName) => {
//     if (!userID || !data?.empid || !data?.token) {
//       toast.error('Missing authentication details');
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await hospitallist('HOSPITAL_ADD', userID, data.empid, data.token, '', {
//         cmd: 'HOSPITAL_ADD',
//         hosp_nm: hospitalName,
//       });

//       if (response?.data) {
//         const detailObject = Array.isArray(response.data)
//           ? response.data[0]
//           : response.data;

//         setSelectedHospitalDetails(detailObject);

//         // Scroll to details
//         setTimeout(() => {
//           detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
//         }, 300);
//       } else {
//         toast.error('No details found for the selected hospital.');
//       }
//     } catch (error) {
//       console.error('Error fetching hospital details:', error);
//       toast.error(error.message || 'Failed to fetch hospital details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'HOSPITAL' && (
//           <Hospital hospitalList={hospitalList} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'ACHC' && (
//           <ACHC achcHospitals={achcHospitals} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'LABS' && (
//           <Labs labs={labs} onHospitalClick={fetchHospitalDetails} />
//         )}
//       </div>

//       {selectedHospitalDetails && (
//         <div ref={detailsRef} className={classes.HospitalDetailsSection}>
//           <HospitalDetails details={selectedHospitalDetails} />
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;




///////////////////////////////////////////////////////////////
////////// New_2 Seperated Code----Its when we click on the Hospitals name then give the details::////////////////////
/////////////////////////////////////////////////////////////
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import { hospitallist } from '../../API/API';
// import Hospital from './Hospital';
// import Labs from './Labs';
// import ACHC from './ACHC';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');
//   const [selectedHospitalDetails, setSelectedHospitalDetails] = useState(null);

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         if (achcResponse?.data) setAchcHospitals(achcResponse.data);
//         if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
//         if (labsResponse?.data) setLabs(labsResponse.data);

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     setCurrentView(viewType);
//     setSelectedHospitalDetails(null); // Clear previously selected details
//   };

//   const fetchHospitalDetails = async (hospitalName) => {
//     if (!userID || !data?.empid || !data?.token) {
//       toast.error('Missing authentication details');
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await hospitallist(
//         'HOSPITAL_ADD',
//         userID,
//         data.empid,
//         data.token,
//         '', // no hosp_type needed
//         { hosp_nm: hospitalName } // extra field to send hospital name
//       );

//       if (response?.data) {
//         setSelectedHospitalDetails(response.data);
//       } else {
//         toast.error('No details found for the selected hospital.');
//       }
//     } catch (error) {
//       console.error('Error fetching hospital details:', error);
//       toast.error(error.message || 'Failed to fetch hospital details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'HOSPITAL' && (
//           <Hospital hospitalList={hospitalList} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'ACHC' && (
//           <ACHC achcHospitals={achcHospitals} onHospitalClick={fetchHospitalDetails} />
//         )}
//         {currentView === 'LABS' && (
//           <Labs labs={labs} onHospitalClick={fetchHospitalDetails} />
//         )}
//       </div>

//       {selectedHospitalDetails && (
//         <div className={classes.HospitalDetails}>
//           <h3>Hospital Details</h3>
//           <pre style={{ backgroundColor: '#f9f9f9', padding: '10px' }}>
//             {JSON.stringify(selectedHospitalDetails, null, 2)}
//           </pre>
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;







/////////////////////////////////////////////////////////////////////////////////////////////////////////////
////-------MY Updated Code-------------////////////////////////////////////
/////////////////#####################################################################################

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         console.log('Fetching data for user:', userID); 
        
//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         if (achcResponse?.data) setAchcHospitals(achcResponse.data);
//         if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
//         if (labsResponse?.data) setLabs(labsResponse.data);

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     console.log('Switching view to:', viewType);
//     setCurrentView(viewType);
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   const renderTable = (dataList, type) => {
//     console.log(`Rendering ${type} list, Count:`, dataList.length);
//     if (!dataList || dataList.length === 0) return <p>No {type} data available.</p>;

//     return (
//       <table className={classes.Table}>
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             <th>Category</th>
//           </tr>
//         </thead>
//         <tbody>
//           {dataList.map((item, index) => (
//             <tr key={index}>
//               <td>{index + 1}</td>
//               <td>{item.hsptl_name}</td>
//               <td>{item.cata}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'ACHC' && <><h2>ACHC Hospitals</h2>{renderTable(achcHospitals, 'ACHC')}</>}
//         {currentView === 'HOSPITAL' && <><h2>List Of Hospitals</h2>{renderTable(hospitalList, 'Hospital')}</>}
//         {currentView === 'LABS' && <><h2>Labs</h2>{renderTable(labs, 'Labs')}</>}
//       </div>
//     </>
//   );
// };

// export default HospitalList;



//////////New Updated Code::::::::::::::::::::::::::::::

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => {
//   const [achcHospitals, setAchcHospitals] = useState([]);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [labs, setLabs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentView, setCurrentView] = useState('');
//   const [hospitalDetails, setHospitalDetails] = useState(null);
//   const [detailsLoading, setDetailsLoading] = useState(false);

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userID || !data?.empid || !data?.token) {
//         setError('Missing authentication details.');
//         return;
//       }

//       setLoading(true);
//       try {
//         const [achcResponse, hospitalsResponse, labsResponse] = await Promise.all([
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'ACHC'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Hospital'),
//           hospitallist('HOSPITAL', userID, data.empid, data.token, 'Lab'),
//         ]);

//         if (achcResponse?.data) setAchcHospitals(achcResponse.data);
//         if (hospitalsResponse?.data) setHospitalList(hospitalsResponse.data);
//         if (labsResponse?.data) setLabs(labsResponse.data);

//         setError(null);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError(error.message || 'Failed to fetch data');
//         toast.error(error.message || 'Failed to fetch data', { icon: '❗', duration: 4500 });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userID, data?.empid, data?.token]);

//   const handleViewChange = (viewType) => {
//     setCurrentView(viewType);
//     setHospitalDetails(null); // Clear details on tab switch
//   };

//   const fetchHospitalDetails = async (hospitalName) => {
//     if (!userID || !data?.empid || !data?.token) {
//       toast.error('Missing authentication details.');
//       return;
//     }

//     setDetailsLoading(true);
//     try {
//       const response = await hospitallist(
//         'HOSPITAL',
//         userID,
//         data.empid,
//         data.token,
//         'HOSPITAL_ADD',
//         { hosp_nm: hospitalName }
//       );

//       if (response?.data) {
//         setHospitalDetails(response.data);
//       } else {
//         toast.error('No hospital details found.');
//         setHospitalDetails(null);
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Failed to fetch hospital details');
//       setHospitalDetails(null);
//     } finally {
//       setDetailsLoading(false);
//     }
//   };

//   const renderTable = (dataList, type) => {
//     if (!dataList || dataList.length === 0) return <p>No {type} data available.</p>;

//     return (
//       <table className={classes.Table}>
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             <th>Category</th>
//           </tr>
//         </thead>
//         <tbody>
//           {dataList.map((item, index) => (
//             <tr key={index}>
//               <td>{index + 1}</td>
//               <td
//                 onClick={() => fetchHospitalDetails(item.hsptl_name)}
//                 className={classes.ClickableName}
//                 style={{ cursor: 'pointer', color: '#007bff' }}
//               >
//                 {item.hsptl_name}
//               </td>
//               <td>{item.cata}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />
//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <button className={classes.Button} onClick={() => handleViewChange('HOSPITAL')}>
//             List Of Hospitals
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('ACHC')}>
//             ACHC
//           </button>
//           <button className={classes.Button} onClick={() => handleViewChange('LABS')}>
//             Labs
//           </button>
//         </div>
//       </div>

//       <div className={classes.HospitalListContainer}>
//         {currentView === 'ACHC' && <><h2>ACHC Hospitals</h2>{renderTable(achcHospitals, 'ACHC')}</>}
//         {currentView === 'HOSPITAL' && <><h2>List Of Hospitals</h2>{renderTable(hospitalList, 'Hospital')}</>}
//         {currentView === 'LABS' && <><h2>Labs</h2>{renderTable(labs, 'Labs')}</>}
//       </div>

//       {detailsLoading && <p>Loading hospital details...</p>}

//       {hospitalDetails && (
//         <div className={classes.HospitalDetailsCard} style={{ marginTop: '20px', border: '1px solid #ccc', padding: '15px', borderRadius: '8px' }}>
//           <h3>Hospital Details</h3>
//           <pre>{JSON.stringify(hospitalDetails, null, 2)}</pre>
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;































































// ==================================================================================================
//   Updated Testing code:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API'; // Import from the API file

// const HospitalList = () => {
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // Toggle to show hospitals

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Validate localStorage data
//         if (!userID || !data?.empid || !data?.token) {
//           throw new Error('Invalid user credentials in localStorage');
//         }

//         // Fetch hospital data
//         const response = await hospitallist(userID, data?.empid, data?.token, 'ACHC');
//         console.log('API response:', JSON.stringify(response, null, 2));

//         // Validate response structure
//         if (response && response.data && Array.isArray(response.data)) {
//           setHospitals(response.data); // Use the correct property name here
//         } else {
//           console.error('Invalid response format:', response);
//           throw new Error('Invalid response format. Expected an array of hospitals.');
//         }
//       } catch (error) {
//         console.error('Error fetching hospital data:', error);
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleACHCButtonClick = () => {
//     setShowHospitals(!showHospitals); // Toggle hospital list visibility
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p style={{ color: 'red' }}>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           <br />
//           <br />
//           <button
//             type="button"
//             style={{ width: '300px', height: '70px', left: '100px' }}
//           >
//             List Of Hospitals
//           </button>
//           <br />
//           <br />
//           <button
//             type="button"
//             style={{ width: '300px', height: '70px' }}
//             onClick={handleACHCButtonClick}
//           >
//             ACHC
//           </button>
//           <br />
//           <br />
//           <button type="button" style={{ width: '300px', height: '70px' }}>
//             Labs
//           </button>
//         </div>
//       </div>

//       {showHospitals && hospitals.length === 0 && (
//         <p>No hospitals available.</p>
//       )}

//       {showHospitals && hospitals.length > 0 && (
//         <div className="hospital-list" style={{ marginTop: '20px' }}>
//           <ul style={{ padding: 0, listStyleType: 'none' }}>
//             {hospitals.map((hospital, index) => (
//               <li
//                 key={index}
//                 style={{
//                   marginBottom: '10px',
//                   padding: '10px',
//                   border: '1px solid #ccc',
//                   borderRadius: '4px',
//                   backgroundColor: '#f9f9f9',
//                 }}
//               >
//                 <h3>{hospital.hospital_name || hospital.name || 'No Name Provided'}</h3>
//                 <p>Location: {hospital.address || hospital.location || 'No Location Provided'}</p>
//                 <p>Type: {hospital.category || hospital.type || 'No Type Provided'}</p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default HospitalList;

















// ##########################################################################################

// --------------Running Code -------##############

// ###########################################################################
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';
// import { hospitallist } from '../../API/API';

// const HospitalList = () => { 

//   const [hospitals, setHospitals] = useState([]); // Ensure hospitals is initialized as an array
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false); // New state for showing hospitals

//   const userID = localStorage.getItem('userID');
//   const data = JSON.parse(localStorage.getItem('data'));

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await hospitallist(userID, data.empid, data.token, 'ACHC');
//         console.log('API response:', response);
//         if (Array.isArray(response)) {
//           setHospitals(response); // Ensure the response is an array before setting it
//         } else {
//           console.error('Invalid response format:', response);
//           // throw new Error('Invalid response format');
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch hospital data');
//         toast.error(error.message || 'Failed to fetch hospital data', {
//           icon: '❗',
//           duration: 4500,
//         });
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [userID, data.empid, data.token]);

//   const handleACHCButtonClick = () => {
//     setShowHospitals(!showHospitals); // Toggle the state
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//       <br /><br />
//         <button
//           type="button"
//           style={{ width: "300px", height: "70px" }}
//           onClick={handleACHCButtonClick}
//         >
//           {showHospitals ? "Hide ACHC List" : "Show ACHC List"}
          
//         </button>
//         <br /><br />
//       </div>

//       {showHospitals && Array.isArray(hospitals) && hospitals.length > 0 && (
//         <div className={classes.hospitalList}>
//           <ul>
//             {hospitals.map((hospital, index) => (
//               <li key={index}>
//                 {hospital.hsptl_name} - {hospital.cata}
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}

//       {/* Debug output */}
//       {showHospitals && (!Array.isArray(hospitals) || hospitals.length === 0) && (
//         <p>No hospitals to display.{hospitallist}</p>
//       )}
//     </>
//   );
// };

// export default HospitalList;

// ###############################################################################
// -------------------Testing_Code--------------

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// import React, { useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../HospitalList/HospitalList.module.scss';
// import './HospitalList.module.scss';

// const HospitalList = () => {
//   const [hospitals, setHospitals] = useState([
//     { hsptl_name: 'Moolchand Hospital', cata: 'ACHC', phone: '123-456-7890', address: 'Location A', timings: '9 AM - 5 PM', },
//     { hsptl_name: 'Yashoda Hospital, Kaushambi', cata: 'ACHC', phone: '098-765-4321', address: 'Location B', timings: '24 Hours' },
//     { hsptl_name: 'Max Group of Hospitals', cata: 'ACHC', phone: '123-123-1234', address: 'Location C', timings: '8 AM - 6 PM' },
//     { hsptl_name: 'Sitaram Bhartia Institute of Science & Research', cata: 'ACHC', phone: '456-456-4567', address: 'Location D', timings: '10 AM - 4 PM' },
//     { hsptl_name: 'General Williams Masonic Polyclinic', cata: 'ACHC', phone: '789-789-7890', address: 'Location E', timings: '9 AM - 7 PM' },
//     { hsptl_name: 'Venkatehswar Hospital', cata: 'ACHC', phone: '101-101-1010', address: 'Location F', timings: '24 Hours' },
    
//   ]);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false);
//   const [expandedHospitals, setExpandedHospitals] = useState({});

//   const handleACHCButtonClick = () => {
//     setShowHospitals((prev) => !prev);
//   };

//   const toggleHospitalDetails = (index) => {
//     setExpandedHospitals((prev) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
//     <>
//       <BreadCrumb name="Hospital List" />

//       <div className={classes.ViewHospital}>
//         <button
//           type="button"
//           style={{ width: "300px", height: "70px" }}
//           onClick={handleACHCButtonClick}
//         >
//           {showHospitals ? "Hide ACHC List" : "Show ACHC List"}
//         </button>
//       </div>

//       {showHospitals && hospitals.length > 0 ? (
//         <div className={classes.hospitalList}>
//           <ul>
//             {hospitals.map((hospital, index) => (
//               <li key={index} className={classes.hospitalItem}>
//                 <button
//                   type="button"
//                   onClick={() => toggleHospitalDetails(index)}
//                   style={{ cursor: "pointer", padding: "10px", width: "100%" }}
//                 >
//                   {hospital.hsptl_name} - {hospital.cata}
//                 </button>
//                 {expandedHospitals[index] && (
//                   <div className={classes.hospitalDetails}>
//                     <p><strong>Phone:</strong> {hospital.phone}</p>
//                     <p><strong>Address:</strong> {hospital.address}</p>
//                     <p><strong>Timings:</strong> {hospital.timings}</p>
//                     {/* <p><strong>Doctor_Name:</strong> {hospital.Doctor_Name}</p> */}
//                   </div>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </div>
//       ) : (
//         showHospitals && <p>No hospitals to display.</p>
//       )}
//     </>
//   );
// };

// export default HospitalList;

// ========================================================================================================
// ========================================================================================================










// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




